export default function Services(){
    return (
        <section className="services" id="services">
            <h1>My Services</h1>
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <div className="card">
                            <h3>Web Development</h3>
                            <p>Creating custom websites that match your brand and meet your needs perfectly, making sure they work flawlessly.</p>
                            <a href="#contact" className="btn btn-primary">Learn More</a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card">
                            <h3>Responsive Design</h3>
                            <p>Designing websites that look great and work well on any device, whether it's a computer, tablet, or phone.</p>
                            <a href="#contact" className="btn btn-primary">Learn More</a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card">
                            <h3>Wix Website Customization</h3>
                            <p>Using Wix's easy-to-use platform to build and personalize websites that showcase your business beautifully.</p>
                            <a href="#contact" className="btn btn-primary">Learn More</a>
                        </div>
                    </div>
                </div>
            </div><br/>
        </section>
    );
}